import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button", "content"]

  show(event) {
    // Touch can synthesize mouse hover before a click. Only real mouse hover opens help.
    if (event.type === "pointerenter") {
      this.hovered = event.pointerType === "mouse"
      if (this.hovered) this.setVisible(true)
    }
    if (event.type === "focusin" && this.buttonTarget.matches(":focus-visible")) this.setVisible(true)
  }

  hide(event) {
    if (event.pointerType !== "mouse") return
    this.hovered = false
    if (!this.buttonTarget.matches(":focus-visible")) this.setVisible(false)
  }

  toggle(event) {
    const mouseClick = event.pointerType === "mouse" || (!event.pointerType && event.detail > 0 && this.hovered)
    // Clicking help that mouse hover already revealed should not make it disappear.
    if (mouseClick && this.hovered && !this.contentTarget.hidden) return
    this.setVisible(this.contentTarget.hidden)
  }

  blur(event) {
    if (!this.element.contains(event.relatedTarget)) this.close()
  }

  outside(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  escape(event) {
    if (event.key === "Escape") this.close()
  }

  close() {
    this.setVisible(false)
  }

  setVisible(visible) {
    this.contentTarget.hidden = !visible
    this.buttonTarget.setAttribute("aria-expanded", String(visible))
  }
}
